// src/hooks/useFieldDefs.js
import { useState, useEffect } from 'react';
import { getAllFields } from '../services/api'; // Asegúrate de que la ruta sea correcta

export const useFieldDefs = () => {
    const [fieldDefs, setFieldDefs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchFieldDefs = async () => {
            try {
                const data = await getAllFields();
                setFieldDefs(data);
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        fetchFieldDefs();
    }, []);

    return { fieldDefs, loading, error };
}